export type BdrSettlementCalendarsActions =
  | BdrSettlementCalendarsBlackoutDatesRequested
  | BdrSettlementCalendarsBlackoutDatesReceived
  | BdrSettlementCalendarsBlackoutDatesFailed
  | BdrSettlementCalendarsBlackoutDatesTimeouted;

export type BdrSettlementCalendarsBlackoutDatesRequested = ReturnType<
  typeof bdrSettlementCalendarsBlackoutDatesRequested
>;

export function bdrSettlementCalendarsBlackoutDatesRequested(currencyCode: string) {
  return {
    type: 'SETTLEMENT_CALENDARS_BLACKOUT_DATES_REQUESTED' as const,
    currencyCode,
  };
}

export type BdrSettlementCalendarsBlackoutDatesReceived = ReturnType<
  typeof bdrSettlementCalendarsBlackoutDatesReceived
>;
export function bdrSettlementCalendarsBlackoutDatesReceived(currencyCode: string, holidays: string[]) {
  return {
    type: 'SETTLEMENT_CALENDARS_BLACKOUT_DATES_RECEIVED' as const,
    currencyCode,
    holidays,
  };
}

export type BdrSettlementCalendarsBlackoutDatesFailed = ReturnType<typeof bdrSettlementCalendarsBlackoutDatesFailed>;

export function bdrSettlementCalendarsBlackoutDatesFailed() {
  return {
    type: 'SETTLEMENT_CALENDARS_BLACKOUT_DATES_FAILED' as const,
  };
}

export type BdrSettlementCalendarsBlackoutDatesTimeouted = ReturnType<
  typeof bdrSettlementCalendarsBlackoutDatesTimeouted
>;

export function bdrSettlementCalendarsBlackoutDatesTimeouted() {
  return {
    type: 'SETTLEMENT_CALENDARS_BLACKOUT_DATES_TIMEOUTED' as const,
  };
}
